export const RND_PROJECTS = [
  {
    title: "ROS 2",
    status: "Completed",
    body: "Develop information exchange pattern for decentralized task choreography using an MTConnect agent and state machine at each device.",
    funder: "Funded by NIST",
    team: "Project Team: Southwest Research Institute (SwRI), MTConnect Institute",
    link: { label: "Project report (PDF) →", href: "https://www.nist.gov/system/files/documents/2019/07/11/nist_ros-i_mtconnect_-_performance_technical_report-end_of_project.pdf" },
  },
  {
    title: "Standards-based dynamic scheduling and job routing",
    status: "Completed",
    body: "Standards-based dynamic scheduling and job routing.",
    funder: "Funded by DMDII",
    team: "Project Team: Xerox PARC, ITAMCO, MTConnect Institute",
  },
  {
    title: "SPEC-OPS",
    status: "Completed",
    body: "Develop real time simulation and verification built on standards.",
    funder: "Funded by DMDII",
    team: "Project Lead: STEP Tools, Inc.",
  },
  {
    title: "Smart Manufacturing Systems (SMS) Testbed",
    status: "Ongoing",
    body: "Demonstrate data collection and storage architecture. Provide a public-facing MTConnect data source, accessible at agent.mtconnect.org.",
    funder: "Funded by and hosted at NIST",
    link: { label: "Open the live agent →", href: "http://agent.mtconnect.org" },
  },
];

export const RND_RESOURCES = [
  {
    title: "More on Google Scholar",
    body: "Search the academic and scientific literature on MTConnect for published research.",
    link: { label: "Search Google Scholar →", href: "https://scholar.google.com/scholar" },
  },
  {
    title: "More on GitHub",
    body: "Find community-maintained open-source tools, utilities, and software. The most popular and widely used projects live here, though others are maintained in their own repositories.",
    link: { label: "Browse github.com/mtconnect →", href: "https://github.com/mtconnect" },
  },
];
